import { CoreMyLeagueTableView } from '../../../../../core/views';
import FantasyLeagueRowView from '../FantasyLeagueRowView';
import { User } from '../../../models';

/**
 * @desc Table My View Class
 * This class using on leagues my page ('fantasy/leagues')
 */
class MyLeagueTableView extends CoreMyLeagueTableView {
	get className() {
		return "my-leagues-table";
	}

	initialize() {
		this.players = this.getOption('players');

		if (User.has_assistant_coach) {
			this.coach = this.getOption( 'coach' );
		}

		super.initialize();
	}

	get childView() {
		return FantasyLeagueRowView;
	}

	get childViewOptions() {
		return {
			...super.childViewOptions,
			rounds: this.rounds,
			players: this.players,
			user_team: this.options.user_team
		}
	}

	fetchRound() {
		const queries = [
			this.rounds.fetch(),
			this.players.fetch(),
			this.options.user_team.fetch()
		];

		if (User.has_assistant_coach) {
			queries.push(this.coach.fetch());
		}

		return Promise.all(queries);
	}

	updateData() {
		if (User.has_assistant_coach) {
			this.players.each(player => {
				const
					actual_round = this.rounds.actual,
					actual_round_id = actual_round.get('id'),
					coach = this.coach.toJSON(),
					bye_rounds = this.rounds
						.filter(
							round => round.get('is_bye') && round.get('status') === 'scheduled'
						).map(round => round.toJSON());

				player
					.setCoachStats({
						coach,
						actual_round_id
					})
					.setByRound({ bye_rounds });
			});
		}

		return this;
	}
}

export default MyLeagueTableView;